import {
  ThreeUpBannerGroup,
  ThreeUpBannerGroupProps,
} from "../components/blocks/three-up-banner/ThreeUpBannerGroup";
import {
  VinoDataImage,
  generateStorefrontImage,
} from "../utils/generate-storefront-image";

import { LinkTo } from "../types";

interface ContentfulThreeUpBannerProps {
  image: VinoDataImage;
  textPosition?: "left" | "right";
  title?: string;
  subtitle?: string;
  titleColor?: string;
  subtitleColor?: string;
  primaryCta?: {
    buttonColour?: string;
    buttonBorderColor?: string;
    buttonTextColor?: string;
    buttonHoverBorderColor?: string;
    buttonHoverBackgroundColor?: string;
    buttonHoverTextColor?: string;
    label?: string;
    LinkTo: LinkTo;
  };
}

interface ContentfulThreeUpBannerGroupProps {
  __typename: string;
  banners: Array<ContentfulThreeUpBannerProps>;
}

const test = ({ __typename }: ContentfulThreeUpBannerGroupProps): boolean =>
  __typename === "VinoData_ThreeUpBannerGroup";

const create = (data: ContentfulThreeUpBannerGroupProps): JSX.Element => {
  const transformedData: ThreeUpBannerGroupProps = {
    ...data,
    banners: data.banners.map((banner) => ({
      ...banner,
      image: generateStorefrontImage(banner.image, {}),
    })),
  };

  return <ThreeUpBannerGroup {...transformedData} />;
};

export default { test, create };
